import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StaticRouter } from 'react-router-dom/server';
import { enableDebug } from '@sitecore-jss/sitecore-jss-react';
import AppRoot from './AppRoot';
import config from './temp/config';
import i18ninit from './i18n';
import TagManager from 'react-gtm-module';
import { loadableReady } from '@loadable/component';
// import loadable from 'react-loadable-visibility/loadable-components';
import Skeleton from './Skeleton';
// import Loading from './components/Foundation/Loading/Loading';

// const AppRoot = loadable(() => import('./AppRoot'), { ssr: true });
// const AppRoot = lazy(() => import('./AppRoot'));
// const TagManager = lazy(() => import('react-gtm-module'));
// const i18ninit = lazy(() => import('./i18n'));
// const config = lazy(() => import('./temp/config'));
// const GraphQLClientFactory = lazy(() => import('./lib/GraphQLClientFactory'));

if (process.env.REACT_APP_DEBUG) {
  enableDebug(process.env.REACT_APP_DEBUG);
}

/* eslint-disable no-underscore-dangle */

let renderFunction = (rootElement, component) => {
  const root = createRoot(rootElement);
  root.render(component);
};

let initLanguage = config.defaultLanguage;

/*
  SSR Data
  If we're running in a server-side rendering scenario,
  the server will provide JSON in the #__JSS_STATE__ element
  for us to acquire the initial state to run with on the client.

  This enables us to skip a network request to load up the layout data.
  We are emitting a quiescent script with JSON so that we can take advantage
  of JSON.parse()'s speed advantage over parsing full JS, and enable
  working without needing `unsafe-inline` in Content Security Policies.

  SSR is initiated from /server/server.js.
*/
let __JSS_STATE__ = null;
const ssrRawJson = document.getElementById('__JSS_STATE__');

const tagManagerArgs = {
  gtmId: 'GTM-KD53L7',
};

TagManager.initialize(tagManagerArgs);

if (ssrRawJson) {
  __JSS_STATE__ = JSON.parse(ssrRawJson.innerHTML);
}
if (__JSS_STATE__) {
  // when React initializes from a SSR-based initial state, you need to render with `hydrateRoot` instead of `render`
  renderFunction = hydrateRoot;

  // set i18n language SSR state language instead of static config default language
  initLanguage = __JSS_STATE__.sitecore.context.language;
}

/*
  App Rendering
*/
// initialize the dictionary, then render the app
// note: if not making a multlingual app, the dictionary init can be removed.
// HTML element to place the app into
const rootElement = document.getElementById('root');

loadableReady(() => {
  renderFunction(
    rootElement,
    <>
      <AppRoot path={window.location.pathname} Router={StaticRouter} ssrState={__JSS_STATE__} />
    </>
  );
});
